import { Pipe, PipeTransform } from '@angular/core'
import { Enums } from '@cyborg-monorepo/hunter/common'
import { BadgeVariant } from '@hyperkit'

@Pipe({
  name: 'severityBadge',
  pure: true,
  standalone: false,
})
export class SeverityBadgePipe implements PipeTransform {
  transform(severity: string): BadgeVariant {
    switch (severity) {
      case Enums.SeverityEnum.LOW:
        return 'success'
      case (Enums.SeverityEnum.MEDIUM, Enums.SeverityEnum.MODERATE):
        return 'warning'
      case Enums.SeverityEnum.HIGH:
        return 'error'
      case Enums.SeverityEnum.CRITICAL:
        return 'secondary'
      default:
        return 'information'
    }
  }
}
